import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import PlacementTestRulerFormContainer from './PlacementTestRulerFormContainer';
import Button from '../../../core/form/Button';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';

const PlacementTestRulerFormScene = props => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: `${props.params.PlacementTestRulerId ? 'Edit Placement Test Ruler' : 'Create Placement Test Ruler'}`,
        },
      ]}
    />
    <Card
      title={props.params.PlacementTestRulerId ? 'Edit Placement Test Ruler' : 'Create Placement Test Ruler'}
      actions={
        (
          <Button
            icon="arrow-left"
            label="Back"
            type="default"
            onClick={() => browserHistory.goBack()}
          />
        )
      }
    >
      <PlacementTestRulerFormContainer placementTestRulerId={props.params.placementTestRulerId} />
    </Card>
  </div>
);

PlacementTestRulerFormScene.propTypes = {
  params: PropTypes.shape({
    placementTestRulerId: PropTypes.string,
  }),
};

PlacementTestRulerFormScene.defaultProps = {
  params: null,
};

export default PlacementTestRulerFormScene;
